export default "__VITE_ASSET__248b2a02__"